import type { GridColTypeDef } from '@packages/fenrir/components/datagrid';
import {
  getFilteredGridSelectOperators,
  GridSelectOperator,
} from '@packages/fenrir/components/datagrid';

import { StringCell } from '../cell/string-cell/string-cell';

export const singleSelectColumnType: GridColTypeDef = {
  display: 'flex',
  flex: 0.2,
  minWidth: 115,
  type: 'singleSelect',
  filterOperators: getFilteredGridSelectOperators([GridSelectOperator.isAnyOf]),
  renderCell: (params) => {
    return <StringCell {...params} />;
  },
};
